<template>
  <div class="offer-manager">
    <div class="alert alert-success" id="search-warning" v-show="searchSuccess">{{searchSuccess}}</div>
    <ul class="nav nav-tabs">
      <li v-for="tab in orderedTabs" :key="tab.name">
        <a class="nav-link" :class="{ active: currentTab === tab.name, disabled: !tab.enabled || loading }" @click="setTab(tab.name)">{{tab.label}} <span :class="tab.numberColor">({{tab.count}})</span></a>
      </li>
      <li class="nav-item flex-grow-1 nav-middle-padding">
        <span id="refresh-warning" v-show="refreshWarning">{{refreshWarning}}</span>
        <button type="button" class="btn btn-primary search-button" id="search-button" @click="searchOffers" v-show="showSearchOfferButton">Show New Offers</button>
        <div class="alert alert-danger streaming-warning" id="search-warning" v-show="showSearchWarning">{{searchWarning}}</div>
        <button type="button" class="btn btn-primary" id="refresh-button"  v-show="showRefreshButton" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-animation='false' data-bs-html="true" title="<em>Only Refresh if a school has failed due to the search expiring.</em>" @click="refreshOffers">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
            <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z"/>
            <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z"/>
          </svg>
        </button>
      </li>
      <li class="nav-item nav-far-right">
        <div class="input-group input-group-sm">
          <span class="input-group-text" id="program-search">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
            </svg>
          </span>
          <input type="text" class="form-control" aria-label="Search offers by program" aria-describedby="program-search" v-model="programSearch">
        </div>
      </li>
    </ul>
    <div class="offer-list-container">
      <div class="manager-header row">
        <div class="col-2">
          <div class="edit-icon text-start">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="#3c763d" stroke-width="2px"/>
            </svg>
          </div>
        </div>
        <div class="col-8" v-if="hasContentInfos">
          <div class="manager-header-title" v-html="headerTitle"></div>
          <div v-html="headerBody"></div>
        </div>
        <div class="col-8 manager-header-title" v-else>The following {{currentTab === 'extra' ? 'offers' : 'schools'}} are available</div>
        <div class="col-2">
          <div class="edit-icon text-end">
            <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1z" stroke="#3c763d" stroke-width="2px"/>
            </svg>
          </div>
        </div>
      </div>
      <OfferList :offers="wtOfferList" :submitted="successfulOffers" :pending="pendingOffers" :wait="wait" v-show="!wait && currentTab === 'warmtransfer' && !showWtPrequestion" :program-search="programSearch" @submit-offer="submitOffer($event, 'Warm Transfer')" @expired="$emit('expired', $event)" @skip-offer="skipOffer"></OfferList>
      <div class="warm-transfer-prequestion container" v-if="showWtPrequestion">
        <div class="title">Have any other offers been submitted within this portal OR any other portals for this prospect?</div>
        <div class="button-row">
          <button class="btn btn-outline-dark" @click="answerWtPrequestion(true)">Yes</button>
          <button class="btn btn-outline-dark" @click="answerWtPrequestion(false)">No</button>
        </div>
      </div>
      <OfferList :offers="cvOfferList" :submitted="successfulOffers" :pending="pendingOffers" :wait="wait" v-show="!wait && currentTab === 'callverified'" :program-search="programSearch" @submit-offer="submitOffer($event, 'Call Verified')" @expired="$emit('expired', $event)" @skip-offer="skipOffer"></OfferList>
      <OfferList :offers="extraOfferList" :submitted="successfulOffers" :pending="pendingOffers" :wait="wait" v-show="!wait && currentTab === 'extra'" :program-search="programSearch" @submit-offer="submitOffer($event, 'Call Verified')" @expired="$emit('expired', $event)" @skip-offer="skipOffer"></OfferList>
      <div class="row loading-row" v-show="currentTab === '' || settingUp || loading || wait || pendingLastOffer">
        <div class="loading-text" v-if="!wait || bulkSubmit">Please wait as we are processing the information.</div>
        <div class="loading-text" v-else>
          Maximum number of {{mostRecentSubmitType}} offers submitted. Please wait until offers are finished processing before submitting more leads.
        </div>
        <img :src="loadingImg" />
      </div>
    </div>

  </div>
</template>
<script>
import { Tooltip } from 'bootstrap'
import { mapState, mapGetters } from 'vuex'
import OfferList from './OfferList.vue'

export default {
  name: 'OfferManager',
  props: ['offers', 'submittedOffers', 'successfulOffers', 'pendingSubmits', 'pendingOffers', 'loading', 'wait', 'extraOnly', 'changeTab', 'bulkSubmit', 'searchRequestInfo', 'newOffersFound', 'searchNewOffersStopped', 'searchNewOffersStarted'],
  emits: ['skipOffer', 'submitOffer', 'refreshOffers', 'searchOffers', 'openBulkSubmit', 'expired'],
  components: {
    OfferList
  },
  data () {
    return {
      currentTab: '',
      programSearch: null,
      refreshWarning: null,
      searchSuccess: null,
      searchWarning: null,
      hasPreviousSubmits: false,
      wtPreQuestionAnswered: false,
      settingUp: true,
      loadingImg: process.env.BASE_URL + 'loading.gif',
      mostRecentSubmitType: null,
      toolTipList: null,
      pendingLastOffer: false
    }
  },
  computed: {
    defaultTab () {
      if (this.currentConsumer && this.currentConsumer.default_tab) {
        return this.currentConsumer.default_tab
      }
      return 'Warm Transfer'
    },
    cvOfferList () {
      return this.offers && this.offers.callVerified ? [...this.offers.callVerified].sort((offer1, offer2) => offer2.sequence - offer1.sequence) : []
    },
    cvCount () {
      return this.cvOfferList.length
    },
    wtOfferList () {
      return this.offers && this.offers.warmTransfer ? [...this.offers.warmTransfer].sort((offer1, offer2) => offer2.sequence - offer1.sequence) : []
    },
    wtCount () {
      return this.wtOfferList.length
    },
    extraOfferList () {
      return this.offers && this.offers.extra ? [...this.offers.extra].sort((offer1, offer2) => offer2.sequence - offer1.sequence) : []
    },
    extraCount () {
      return this.extraOfferList.length
    },
    currentTabObject () {
      var current = this.orderedTabs.find((tab) => tab.name === this.currentTab)
      return current
    },
    currentTabCount () {
      if (this.currentTabObject) {
        return this.currentTabObject.count
      }
      return 0
    },
    orderedTabs () {
      var wtTab = { name: 'warmtransfer', label: 'Warm Transfer', count: this.wtCount, enabled: this.wtCount > 0 && !this.hasPreviousSubmits && this.submittedOffers.length === 0 && this.pendingSubmits.length === 0, numberColor: '' }
      var cvTab = { name: 'callverified', label: 'Call Verified', count: this.cvCount, enabled: this.cvCount > 0, numberColor: '' }
      var extraTab = { name: 'extra', label: 'Extra Offers', count: this.extraCount, enabled: this.extraCount > 0, numberColor: '' }
      var tabList = !this.extraOnly ? [wtTab, cvTab] : []
      if (extraTab.count > 0) {
        tabList.push(extraTab)
      }
      var defaultIndex = tabList.findIndex((tab) => tab.label === this.defaultTab)
      if (defaultIndex > 0) {
        var toMove = tabList.splice(defaultIndex, 1)[0]
        tabList.unshift(toMove)
      }
      return tabList
    },
    showWtPrequestion () {
      return this.currentTab === 'warmtransfer' && this.currentConsumer && this.currentConsumer.warm_transfer_question && !this.wtPreQuestionAnswered
    },
    showSearchOfferButton () {
      return this.currentConsumer && this.currentConsumer.search_button && this.newOffersFound
    },
    showRefreshButton () {
      return this.currentConsumer && !this.currentConsumer.search_button
    },
    showSearchWarning () {
      return this.searchWarning && !this.showSearchOfferButton
    },
    hasContentInfos () {
      console.log(this, 'this')
      return this.contentTextInfos.length > 0
    },
    headerTitle () {
      if (this.currentTab === 'extra') {
        return this.mapText(this.contentTextInfos[0].extra_offer_title)
      }
      if (this.currentTab === 'warmtransfer') {
        return this.mapText(this.contentTextInfos[0].warm_transfer_title)
      }

      return this.mapText(this.contentTextInfos[0].call_verified_title)
    },
    headerBody () {
      if (this.currentTab === 'extra') {
        return this.mapText(this.contentTextInfos[0].extra_offer_body)
      }
      if (this.currentTab === 'warmtransfer') {
        return this.mapText(this.contentTextInfos[0].warm_transfer_body)
      }

      return this.mapText(this.contentTextInfos[0].call_verified_body)
    },
    ...mapState({
      consumerId: state => state.consumer.consumerId,
      currentConsumer: state => state.consumer.currentConsumer,
      contentTextInfos: state => state.consumer.contentTextInfos
    }),
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  methods: {
    skipOffer (skipInfo) {
      this.$emit('skipOffer', skipInfo)
    },
    goToTabWithOffers () {
      this.pendingLastOffer = false
      if (this.loading) {
        return
      }
      if (this.currentTabCount > 0 && this.currentTabObject.enabled) {
        return
      }
      var firstWithOffers = this.orderedTabs.find((tab) => tab.count > 0 && tab.enabled)
      if (firstWithOffers) {
        this.currentTab = firstWithOffers.name
      } else if (!this.loading && this.pendingSubmits.length === 0) {
        if (!this.searchNewOffersStarted) {
          if (this.submittedOffers.length > 0) {
            this.$router.push(`/consumer/${this.consumerId}/success`)
          } else {
            this.$router.push(`/consumer/${this.consumerId}/no-offers`)
          }
        } else {
          this.pendingLastOffer = true
        }
      } else if (!this.loading) {
        if (this.bulkSubmit) {
          this.$emit('openBulkSubmit')
        } else {
          this.pendingLastOffer = true
        }
      }
    },
    refreshOffers () {
      if (!this.loading) {
        this.toolTipList.forEach((tt) => tt.hide())
        this.$emit('refreshOffers')
      } else {
        this.refreshWarning = 'Please wait for all offers to load'
        setTimeout(() => { this.refreshWarning = null }, 5000)
      }
    },
    searchOffers () {
      this.searchAlertSuccess = true
      if (!this.loading) {
        this.toolTipList.forEach((tt) => tt.hide())
        this.$emit('searchOffers')
      } else {
        setTimeout(() => { this.searchWarning = null }, 5000)
      }
    },
    answerWtPrequestion (answer) {
      this.hasPreviousSubmits = answer
      this.wtPreQuestionAnswered = true
      this.goToTabWithOffers()
    },
    async finishSetup () {
      await new Promise((resolve) => setTimeout(resolve, 200))
      var tooltipTriggerList = [].slice.call(document.querySelectorAll('.offer-manager [data-bs-toggle="tooltip"]'))
      this.toolTipList = tooltipTriggerList.map((tooltipTriggerEl) => new Tooltip(tooltipTriggerEl))
      this.settingUp = false
    },
    setTab (tabName) {
      if (!this.loading) {
        this.currentTab = tabName
      }
    },
    submitOffer (event, listType) {
      this.mostRecentSubmitType = listType
      this.$emit('submitOffer', event)
    },
    manipulateSearchRequestInfo () {
      if (Object.keys(this.searchRequestInfo).length) {
        var searchRequestInfo = this.searchRequestInfo.offers.filter((offer) =>
          Array.isArray(offer.offer_external_name_ids) ? !offer.offer_external_name_ids.some(id => this.submittedOffers.includes(id)) : !this.submittedOffers.includes(offer.offer_external_name_ids)
        )
        if (searchRequestInfo.length > 0) {
          this.searchSuccess = searchRequestInfo.length + ' new offer(s) have been added to the list.'
          if (searchRequestInfo.find(offer => !offer.is_warm_transfer)) {
            this.orderedTabs.find((tab) => tab.name === 'callverified').numberColor = 'offers-found'
          }
          if (searchRequestInfo.find(offer => offer.is_warm_transfer)) {
            this.orderedTabs.find((tab) => tab.name === 'warmtransfer').numberColor = 'offers-found'
          }
        }
      }
    },
    mapText (text) {
      const leadFields = [['__consumer_phone__', 'phone1'],
        ['__consumer_name__', 'fullname'],
        ['__consumer_email__', 'email'],
        ['__consumer_firstname__', 'firstname'],
        ['__consumer_lastname__', 'lastname'],
        ['__agent_id__', 'agent_id'],
        ['__agent_name__', 'agent_name'],
        ['__call_center_dba__', 'call_center_dba'],
        ['__consumer_address__', 'address'],
        ['__consumer_city__', 'city'],
        ['__consumer_state__', 'state'],
        ['__consumer_zip__', 'zip']]

      if (this.leadInfo) {
        leadFields.forEach((item) => {
          text = text.replace(new RegExp(item[0], 'g'), this.leadInfo[item[1]] ?? '')
        })
      }
      return text
    }
  },
  mounted () {
    this.finishSetup()
    if (this.cvCount + this.wtCount + this.extraCount > 0) {
      this.goToTabWithOffers()
    }
  },
  watch: {
    wtCount (newCount) {
      if (this.pendingSubmits.length === 0) {
        this.goToTabWithOffers()
      }
    },
    cvCount (newCount) {
      if (this.pendingSubmits.length === 0) {
        this.goToTabWithOffers()
      }
    },
    extraCount (newCount) {
      this.goToTabWithOffers()
    },
    changeTab () {
      this.goToTabWithOffers()
    },
    loading (isLoading) {
      if (!isLoading) {
        this.goToTabWithOffers()
      }
    },
    searchRequestInfo (newCount) {
      this.manipulateSearchRequestInfo()
    },
    searchNewOffersStopped () {
      this.searchWarning = 'All potential offers returned'
    }
  }
}
</script>

<style scoped>
.alert{
  padding: 0.5rem 0.5rem !important;
}
.nav-middle-padding {
  text-align: right;
  padding-right: 5px;
}
#refresh-button {
  padding-top: 2px;
  padding-bottom: 3px;
  background-color: #5bc0de;
  border-color: #46b8da;
}
.nav.nav-tabs {
  background-color: white;
  position: sticky;
  top: 0;
  width: calc(100% - 5px);
  margin-left: 2px;
  padding-left: 10px;
}
.nav-far-right {
  margin-right: -3px;
}
.manager-header {
  padding-top: 15px;
  padding-bottom: 15px;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  position: sticky;
  top: 40px;
  z-index: 5;
  background-color: white;
  border-bottom: #ccd0d4 solid 1px;
}
.manager-header-title {
  font-size: 18px;
  font-weight: bold;
}
.offer-list-container {
  border-right: 1px solid #dee2e6;
  border-left: 1px solid #dee2e6;
  border-bottom: 1px solid #dee2e6;
  border-radius: 4px;
}
#refresh-warning {
  padding-right: 25px;
}
.edit-icon {
  padding-left: 14px;
  padding-right: 14px;
}
.edit-icon svg{
  height: 2em;
}
a.nav-link {
  cursor: pointer;
}
.warm-transfer-prequestion .button-row .btn {
  width: 25%;
  margin-right: 15px;
  font-size: 12px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.warm-transfer-prequestion {
  padding-bottom: 15px;
}
.warm-transfer-prequestion .title {
  font-weight: 700;
}
.loading-row {
  padding-top: 30px;
  padding-bottom: 30px;
}
.loading-row img {
  height: 70px;
  width: auto;
  margin: auto;
}
.loading-text {
  text-align: center;
  margin: auto;
}
.search-button {
    margin: 0px 4px;
    padding: 0.17rem 0.5rem;
}
.offers-found {
  color: #4ca539;
  font-weight: bold;
}

.streaming-warning {
  float: right;
  padding: 0.2rem 0.5rem !important;
}
</style>
